import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { RolesAndPermissions } from '../../models/roles-and-permissions';
import { AppSettings } from '../../utils/app-settings';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private http: HttpClient) { }
  private _permissions: ReplaySubject<RolesAndPermissions> = new ReplaySubject<RolesAndPermissions>(1);
  
  private _fetched = false;
  private _fetching = false;

  public getPermissionsForUser() {
    if (this._fetched || this._fetching) {
      return this._permissions.asObservable();
    }
    this._fetching = true;
    this.http.get(AppSettings.apiUrl + 'users/permissions')
      .subscribe((res) => {
        this._permissions.next(new RolesAndPermissions(res));
        this._fetched = true;
        this._fetching = false;
      });
      return this._permissions.asObservable();
  }
}
